module.exports = __webpack_public_path__ + "mk4-tractor.538b9281660211662d7d.png";


//////////////////
// WEBPACK FOOTER
// /Users/ranjith/eclipse-workspace/monarch-web-contentful/src/assets/img/mk4-tractor.png
// module id = ../../../../../src/assets/img/mk4-tractor.png
// module chunks = styles